import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { useTranslation, withTranslation } from "react-i18next"

import CheckIcon from "../../../images/icons/check.svg"
import "./career-benefits-list.sass"

const CareerBenefitsList = ({ benefits }) => {
  const { t } = useTranslation()

  return (
    <div className={"_fp-benefits-list"}>
      {benefits.map((item, index) => {
        return (
          <div key={index} className={classNames("_fp-benefits-list__benefit")}>
            <div className="_fp-benefits-list__benefit__check">
              <CheckIcon />
            </div>
            <div className="_fp-benefits-list__benefit__title _fp-text">
              {item}
            </div>
          </div>
        )
      })}
    </div>
  )
}

CareerBenefitsList.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
}

export default CareerBenefitsList
